module.exports = __webpack_public_path__ + "assets/img/编组 6@2x (1).cf0796e2.png";